module.exports = __webpack_public_path__ + "img/carrier-logo.3f2d4860.png";